import React from 'react';

export default function List() {
  return (
    <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-rows gap-8 items-center justify-items-center font-[Rubik] mb-20">
      <div className="text-center px-7">
        <p className="text-black xl:text-[22px] md:text-lg text-base font-bold">
          Wisata Populer & Budaya Populer
        </p>
        <p className="text-[#999999] text-base mt-[27px]">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nisl, magna lobortis nunc,
          aliquet leo amet at amet. Nisl vitae ornare tristique et a.
        </p>
      </div>
      <div>
        <img src="/assets/images/image-1.png" alt="" className="md:w-full" />
      </div>
      <div>
        <img src="/assets/images/image-1.png" alt="" className="md:w-full" />
      </div>
      <div>
        <img src="/assets/images/image-1.png" alt="" className="md:w-full" />
      </div>
    </div>
  );
}
